import { IContext, OrganizationContext } from 'contexts/organizationContext';
import { useContext } from 'react';

export const useOrganizationContext = (): IContext => {
  return useContext<IContext>(OrganizationContext);
};
